import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Revenue from './icon-revenue.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Revenue {...validProps} />;
}
SvgComponent.iconName = 'revenue';

/**
 * @deprecated This is a legacy icon
 */
export const RevenueIcon = svgIconWrapper(SvgComponent);
